export default "__VITE_ASSET__eXdFnp3C__ 100w";